import { Loader, Table } from "@mantine/core";
import "./ETable.scss";

type Props = {
  hasEndButtons?: boolean;
  children: JSX.Element | JSX.Element[];
  isLoading?: boolean;
};

export function ETable({ children, hasEndButtons, isLoading }: Props) {
  return (
    <Table.ScrollContainer minWidth={800}>
      <Table
        highlightOnHover
        verticalSpacing={'xs'}
        horizontalSpacing={'md'}
        striped={'even'}
        // withColumnBorders={true}
        className={"e-table " + (hasEndButtons ? "end-btns" : "")}
      >
        {isLoading ? <Table.Tr>
          <Table.Td colSpan={12}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "65vh" }}>
              <Loader />
            </div>
          </Table.Td>
        </Table.Tr> : children}
      </Table>
    </Table.ScrollContainer>
  );
}
